import React from "react";
import FooterOwner from "./FooterOwner";
import FooterRecruiter from "./FooterRecruiter";
import FooterNormal from "./FooterNormal";
import { useSelector } from "react-redux";

const FooterRouter = ({handlerCertified,handlerPersonalise , requestCvRef , requestInterviewRef}) => {
    const variant = useSelector((store)=> store?.certificateVerification?.userType);

  if (variant === "owner") {
    return <FooterOwner handlerCertified={handlerCertified} handlerPersonalise={handlerPersonalise}/>;
  } else if (variant === "recruiter") {
    return <FooterRecruiter  requestCvRef={requestCvRef} requestInterviewRef={requestInterviewRef} handlerCertified={handlerCertified} handlerPersonalise={handlerPersonalise}/>
  } else {
    return <FooterNormal requestCvRef={requestCvRef} handlerCertified={handlerCertified} handlerPersonalise={handlerPersonalise} />
  }
};

export default FooterRouter;
